import {
	IconBuildingStore,
	IconKey,
	IconMapPin,
	IconTruckDelivery,
	IconUserDollar,
	IconUsers,
} from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/page-header";
import { type Section, SectionLinks } from "@/components/section-links";

/** Instellingen: shipping rules, price groups, locations, employees, tokens and company details, each a page of its own. */
export const Route = createFileRoute("/_admin/settings/")({
	component: SettingsPage,
});

/** One line per settings page that exists, in the spec's order. */
// biome-ignore format: one line per section, so parallel branches merge without touching each other's lines
const sections: readonly Section[] = [
	{ to: "/settings/shipping-rule", icon: IconTruckDelivery, namespace: "shippingRule" },
	{ to: "/settings/customer-group", icon: IconUserDollar, namespace: "price" },
	{ to: "/settings/location", icon: IconMapPin, namespace: "location" },
	{ to: "/settings/employee", icon: IconUsers, namespace: "employee" },
	{ to: "/settings/token", icon: IconKey, namespace: "personalAccessToken" },
	{ to: "/settings/company-details", icon: IconBuildingStore, namespace: "companyDetails" },
];

function SettingsPage() {
	const { t } = useTranslation("settings");
	return (
		<div className="flex flex-col gap-6">
			<PageHeader title={t("title")} description={t("description")} help="settings:settings" />
			<SectionLinks sections={sections} />
		</div>
	);
}
